// function* getHqSaga(action: HqAction): Generator {
//   if (action.type !== GET_HQ) return
// }

export default function* hqConfigSaga(): Generator {
  // yield* all([takeLatest(GET_HQ, getHqSaga)])
}
